"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var RpcError_1 = __importDefault(require("../../jsonrpc/response/RpcError"));
var addDebugData_1 = __importDefault(require("./addDebugData"));
var transformErrorToException = function (response, request) {
    (0, addDebugData_1.default)(response, request);
    if (Array.isArray(response) && response.some(function (el) { return el instanceof RpcError_1.default; })) {
        throw response;
    }
    if (response instanceof RpcError_1.default) {
        throw response;
    }
    return Promise.resolve(response);
};
exports.default = transformErrorToException;
//# sourceMappingURL=transformErrorToException.js.map